import React, { useEffect, useState } from "react";
import "./styles/chatAdminScreen.css";
import SideBar from "../../Common/SideBar";
import { useDispatch, useSelector } from "react-redux";
import { Outlet } from "react-router-dom";

export default function ChatIndexScreen() {
  const sidebar = useSelector((state) => state.sidebar);

  return (
    <div className="MainContainer">
      <SideBar />
      <Outlet />
    </div>
  );
}
